import React from 'react'

import { OrderableSelect } from '../OrderableSelect'
import ModalWindow from '../../layout/ModalWindow'

import './column-select.scss'

export default function ColumnSelect (props) {
  const { setColumns, defaultColumns, open, close, title } = props

  const resetToDefault = () => setColumns(defaultColumns)

  const modal = () => (
    <ModalWindow
      isOpen={open}
      closeModal={close}
      className="column-select"
    >
      <h3>{title || 'Column Selection'}</h3>
      <OrderableSelect {...props} onChange={setColumns} />
      <div className="options">
        <button className="ok" onClick={close}>Ok</button>
        <button className="default" onClick={resetToDefault}>Default</button>
      </div>
    </ModalWindow>
  )

  return open ? modal() : null
}
